export default __webpack_public_path__ + "static/media/WStore_Icon_Montgomery.aebce60a.png";